<template>
  <div class="hello">
    <div class="case">
      <!-- 头部 -->
      <div class="top">
        <div class="ti-blck"></div>
        <div class="title">Registered to attend the Drone World Congress 2020！</div>
        <p
          class="introduce"
        >This form should take no more than 5 mins to fill in. Thank you for your interest for DWC, we look forward to seeing you in September. Last but not least, should you have questions in filling this form, please don't hesitate to contact: <a href="mailto:int@wuavf.com">int@wuavf.com</a></p>
        <p class="must">*必填</p>
      </div>
      <!-- 尾部 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
      <div class="tail">
          <el-form-item prop="name">
            <label>Name  <span class="sign">*</span></label>
            <el-input v-model="ruleForm.name" type="text" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="Nationality">
            <label>Nationality   <span class="sign">*</span></label>
            <el-input v-model="ruleForm.Nationality" placeholder="您的回答"></el-input>
          </el-form-item>
          
        </div>
        <div class="tail">   
          <el-form-item prop="phone">
            <label>Contact Number <span class="sign">*</span></label>
            <el-input v-model="ruleForm.phone" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
         <div class="tail">
           
          <el-form-item prop="Company">
            <label>Company   <span class="sign">*</span></label>
            <el-input v-model="ruleForm.Company" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <div class="cause">
            Please let us know which category meet your company's focus
            <span
              class="sign"
            >*</span>
          </div>
          <el-form-item prop="companytype">
            <el-checkbox-group v-model="ruleForm.companytype">
              <el-checkbox label="Agriculture UAV/UAS" name="type"></el-checkbox>
              <br />
              <el-checkbox
                label="Fire Fighting UAV/UAS"
                name="companytype"
              ></el-checkbox>
              <br />
              <el-checkbox label="Transporting Drones" name="companytype"></el-checkbox>
              <br />
              <el-checkbox
                label="Consumer Drones"
                name="companytype"
              ></el-checkbox>
              <br />
              <el-checkbox label="Rescue Drones" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="UAV/UAS R&D" name="companytype"></el-checkbox>
              <br />
              <el-checkbox label="其他:" name="companytype"></el-checkbox>
              <br />
              <el-input class="elseinp" v-model="ruleForm.comtype_other" placeholder="请填写 “其他” 原因描述"></el-input>
            </el-checkbox-group>
            
          </el-form-item>
        </div>
        <div class="tail">
           
          <el-form-item prop="position">
            <label>Job Title   <span class="sign">*</span></label>
            <el-input v-model="ruleForm.position" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <div class="cause">
            Attend forums (Sep13-Sep15)
            <span
              class="sign"
            >*</span>
          </div>
          <el-form-item prop="forum">
            <el-checkbox-group v-model="ruleForm.forum">
              <el-checkbox label="2020 World Drone Conference Plenary Session (September 13th)" name="forum"></el-checkbox>
              <br />
              <el-checkbox
                label="International Precision Agriculture Aviation Conference (additional charge)"
                name="forum"
              ></el-checkbox>
              <br />
              <el-checkbox label="ArduPilot Conference (additional charge)" name="forum"></el-checkbox>
              <br />
              <el-checkbox
                label="Police Drone Summit Forum"
                name="forum"
              ></el-checkbox>
              <br />
              <el-checkbox label="Military-civilian integration unmanned equipment forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Anti UAV Technology and Airport Security Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="UAV Surveying and Mapping Technology Application Summit Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Fire Prevention Drone Application Innovation Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="5G + and Unmanned System Application Summit" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Drone Education Training and Development Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Drone Power Inspection Application Seminar" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Earthquake Emergency Rescue UAV Application Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Drone Standard Innovation Forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Symposium on new materials and technologies for drones" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="Chinese and foreign drone presidents forum" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="UAV Aerial Photography Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="5G Robot Summit Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Transportation Drone Application Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Marine UVA Systems Forum" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Drone testing and certification seminar" name="forum"></el-checkbox>
              <br />
               <el-checkbox label="Company Visit [September 15th]" name="forum"></el-checkbox>
              <br />
              <el-checkbox label="其他:" name="forum"></el-checkbox>
              <br />
              <el-input class="elseinp" v-model="ruleForm.forum_other" placeholder="请填写 “其他” 原因描述"></el-input>
            </el-checkbox-group>
            
          </el-form-item>
        </div>
        <el-form-item>
          <el-button class="subbin" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      ruleForm: {
        name: '',
        Nationality: '',
        phone: '',
        Company: '',
        companytype: [],
        comtype_other: '',
        position: '',
        forum: [],
        forum_other: '',
      },
      rules: {
        name: [{required: true, message: '此问题必须填写', trigger: 'blur' }],
        Nationality: [{required: true, message: '此问题必须填写', trigger: 'blur' }],
        phone: [
          {required: true, message: '此问题必须填写', trigger: 'blur' },
          { min: 11, message: '请输入正确的联系方式', trigger: 'blur' }],
        Company: [{required: true, message: '此问题必须填写', trigger: 'blur' }],
        companytype: [
          {
            type: "array",
            required: true,
            message: "至少选择一项",
            trigger: "change"
          }
        ],
        position: [{required: true, message: '此问题必须填写', trigger: 'blur' }],
        forum: [
          {
            type: "array",
            required: true,
            message: "至少选择一项",
            trigger: "change"
          }
        ],
      }
    };
  },
  beforeCreate() {
     
  },
   created(){
     
    //记录访问数量
     this.$axios({
      url:
        "http://en.droneworldcongress.com/form/index/yes_speaker/index.html?button_id=" +
         this.$route.query.button_id +
        "&contacts_id=" +
        this.$route.query.contacts_id,
      method: "post",
      data: {}
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let button_id = this.$route.query.button_id;
          let contacts_id = this.$route.query.contacts_id;
          // alert(this.ruleForm.Nationality);
          let permission = this.ruleForm.companytype.join(",");
          let forum = this.ruleForm.forum.join(",");
          let url = "http://en.droneworldcongress.com/form/index/yes_speaker/index.html=" +button_id +"&contacts_id=" + contacts_id
          this.$axios({
            url:
              "http://en.droneworldcongress.com/form/index/yes_speaker/index.html?button_id=" +
              button_id +
              "&contacts_id=" +
              contacts_id,
            method: "post",
            data: {
              name: this.ruleForm.name,
              nationality: this.ruleForm.Nationality,
              company: this.ruleForm.phone,
              contact_number: this.ruleForm.Company+this.ruleForm.comtype_other,
              company_focus: permission,
              job: this.ruleForm.position,
              attend_forums: forum+this.ruleForm.forum_other,
              url: url
            }
          })
            .then(res => {
              if(res.status == 0){
                this.$message({
                message: '提交失败',
                type: 'warning'
              });
              }{
                     this.$router.push({name:'succSpeaker'});
              }
              
            })
            .catch(err => {
              this.$message({
                message: '提交失败',
                type: 'warning'
              });
            });
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.case {
  margin: auto;
  max-width: 90vw;
  width: 640px;
  padding-top: 12px;
}
.hello {
  width: 100%;
  height: 100%;
  background-color: rgb(240, 235, 248);
  background-size: 100% 100%;
}
.top {
  /* margin-top: 12px; */
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  padding-top: 22px;
  position: relative;
  text-align: left;
}
.ti-blck {
  background-color: rgb(103, 58, 183);
  color: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: calc(100% + 2px);
}
.title {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  color: #202124;
  line-height: 135%;
  max-width: 100%;
  min-width: 0%;
}
.introduce {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  color: #202124;
  margin-top: 12px;
}
.must {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  margin-top: 12px;
  color: #d93025;
}
.el-checkbox{
    white-space: pre-line !important;
}
.el-checkbox__label{
    display: initial !important;
}

/* 尾部 */
.tail {
  -webkit-transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  page-break-inside: avoid;
  word-wrap: break-word;
  text-align: left;
}
.cause {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  color: #202124;
  font-weight: 400;
  width: 100%;
  word-break: break-word;
}
.form-inp {
  margin-left: 0px !important;
}
.sign {
  color: #d93025;
}
/* .elseinp {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #42b983;
} */
.subbin{
  background-color: rgb(103, 58, 183);
  margin-bottom: 20%;
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Speaker.vue